export default "__VITE_ASSET__03e47499__"